// common logic related to authorization
import auth from "@/identity/auth"

// async — resolves to a Bearer header for a fresh ID token, or "" when not
// authenticated. Token refresh is transparent; callers must await.
export const bearerHeader = async function (): Promise<string> {
  const token = await auth.getIdToken()
  if (!token) return ""
  return `Bearer ${token}`
}

// ── The admin Hasura role ───────────────────────────────────────────────────
//
// heavybit_admin, the Stytch audience role of the same name. The old name
// (site_admin) is gone from Hasura, and the cutover revoked every session
// that carried it, so there is no other name to ask for.
export const ADMIN_ROLE = "heavybit_admin"

/** Apollo `context` for a request that must run as the admin role. */
export function asAdmin(): { headers: { "x-hasura-role": string } } {
  return { headers: { "x-hasura-role": ADMIN_ROLE } }
}
